<template>
    <div class="x_box A4">
        <div class="x_body">
            <div class="print-header font-m">
                <h2 class="text-center" style="font-weight: bold;">{{company.Name}}</h2>
                <p class="text-center">{{$now().format('DD/MM/YYYY HH:mm A')}}</p>
                <h3 class="text-center">{{$t('stock_transfer')}}</h3>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <table style="width: 100%;">
                        <tbody>
                        <tr>
                            <td style="width: 100px;">{{ $t('branch_from') }}</td>
                            <td style="width: 10px;">:</td>
                            <td>{{header.FromBranchName}}</td>
                        </tr>
                        <tr>
                            <td style="width: 100px;">{{ $t('branch_to') }}</td>
                            <td style="width: 10px;">:</td>
                            <td>{{header.ToBranchName}}</td>
                        </tr>
                        <tr>
                            <td>សំគាល់</td>
                            <td>:</td>
                            <td>{{header.Remark}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-sm-6">
                    <table align="right">
                        <tbody>
                        <tr>
                            <td>{{$t('barcode')}}</td>
                            <td>:</td>
                            <td>{{header.Num}}</td>
                        </tr>
                        <tr>
                            <td>{{$t('date')}}</td>
                            <td>:</td>
                            <td>{{$format(header.Date, 'DD/MM/YYYY')}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <br/>
            <div class="row">
                <div class="col-sm-12">
                    <table class="table table-bordered table-sm no-bor">
                        <thead>
                        <tr>
                            <th class="text-center" style="width: 50px;">{{$t('no')}}</th>
                            <th>{{$t('item_code')}}</th>
                            <th>{{$t('item_name')}}</th>
                            <th>{{$t('description')}}</th>
                            <th class="text-right">{{$t('qty')}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(ret,index) in lines" :key="index">
                            <td>{{index + 1}}</td>
                            <td>{{ret.ItemNum}}</td>
                            <td>{{ret.ItemName}}</td>
                            <td>{{ret.Description}}</td>
                            <td class="text-right">{{ret.Quantity}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "StockTransfer",
        data() {
            return {
                company: '',
                header: {
                    IsApproved: true
                },
                lines: []
            }
        },
        created() {
            this.getCompany();
            var id = this.$route.params.id;
            if (id !== undefined && id != null && id !== '') {
                this.findById(id);
            }
        },
        methods: {
            getCompany: function () {
                this.$api().post("company").then(res => {
                    this.company = res.data.Data;
                });
            },
            findById(id){
                let loading = this.$loading.show();
                this.$api().post('stock/transfer/find', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.header = res.data.Json.Header;
                        this.lines = res.data.Json.Lines;
                    }
                }).finally(function(){ loading.hide(); });
            },
        }
    }
</script>
